import styled from 'styled-components';
import { css } from '@styled-system/css';

import { lcTextCardProps } from 'humanity/components/lcTextCard/lcTextCard.types.js';
import SimpleRichText from 'humanity/components/simpleRichText';
import Box from 'humanity/primitives/box';
import Heading from 'humanity/primitives/heading';
import { theme } from 'utils/theme.v2';

const StyledBox = styled(Box)(
  css({
    backgroundColor: theme.colors.backgroundLightGray2,
    padding: theme.space[6],
    borderRadius: theme.radii.sm,
  })
);

const LcTextCard = ({ title, content }) => (
  <StyledBox>
    <Heading variant="h4">{title}</Heading>
    <SimpleRichText content={content.json} />
  </StyledBox>
);

LcTextCard.propTypes = {
  ...lcTextCardProps,
};

export default LcTextCard;
